/**
 * Created by andrey on 17.09.2024
 */

Map2d.unitsVisible = true;

Map2d.setUnitsVisible = function (unitsVisible) {
    Map2d.unitsVisible = unitsVisible;

    Map2d.updateMap();
};

Map2d.resetChessLayerVisible = function () {
    Map2d.chessLayerVisible = !!Map2dChessGroundView.IsEnabled();
};

Map2d.setChessLayerVisible = function (chessLayerVisible) {
    Map2d.chessLayerVisible = chessLayerVisible;

    Map2d.updateMap();
};

Map2d.impassableCellsVisible = false;

Map2d.setImpassableCellsVisible = function (impassableCellsVisible) {
    Map2d.impassableCellsVisible = impassableCellsVisible;

    Map2d.updateMap();
};

Map2dLayerView.prototype.showLayerTile = cleverapps.extendFunc(Map2dLayerView.prototype.showLayerTile, function (layer, x, y) {
    this._super(layer, x, y);

    if (!Map2d.impassableCellsVisible || layer !== Map2d.LAYER_GROUND) {
        return;
    }

    if (!this.map2d.isValid(x, y)) {
        return;
    }

    const water = this.map2d.getValue(Map2d.LAYER_WATER, x, y);
    const ground = this.map2d.getValue(Map2d.LAYER_GROUND, x, y);
    const isWaterUnit = water === Map2d.TILE_WATER_UNIT;
    const isImpassable = water === Map2d.TILE_WATER || water === Map2d.TILE_WATER_UNIT
        || ground === Map2d.TILE_IMPASSABLE_LEVEL_1 || ground === Map2d.TILE_IMPASSABLE_LEVEL_2
        || this.map2d.getValue(Map2d.LAYER_BORDERS, x, y) instanceof BorderTile;

    const cellView = this.cells[y] && this.cells[y][x];
    if (cellView && cellView.children.some((child) => child instanceof Map2dChessGroundView)) {
        return;
    }

    const overlay = Map2dChessGroundView.GetFromPool(bundles.dev_resources.frames.chess_debug);
    if (overlay) {
        let color = cc.color(0, 255, 0);
        if (isWaterUnit) {
            color = cc.color(0, 0, 255);
        } else if (isImpassable) {
            color = cc.color(255, 0, 0);
        }
        overlay.setColor(color);
        this.map2dView.addTile(Map2d.LAYER_GROUND, x, y, overlay);
    }
});

Map2d.decoratorsVisible = true;

Map2d.setDecoratorsVisible = function (decoratorsVisible) {
    Map2d.decoratorsVisible = decoratorsVisible;

    Map2d.updateMap();
};

Map2d.groundVisible = true;

Map2d.setGroundVisible = function (groundVisible) {
    Map2d.groundVisible = groundVisible;

    Map2d.updateMap();
};

Map2d.backgroundVisible = true;

Map2d.setBackgroundVisible = function (backgroundVisible) {
    Map2d.backgroundVisible = backgroundVisible;

    const map2d = Map2d.currentMap;
    if (!map2d) {
        return;
    }
    const mapView = map2d.getMapView();
    if (mapView && mapView.background) {
        mapView.background.setVisible(backgroundVisible);
    }
};

Map2d.updateMap = function () {
    const map2d = Map2d.currentMap;

    if (!map2d) {
        return;
    }

    const toRemove = [];

    for (let y = 0; y < map2d.getHeight(); y++) {
        for (let x = 0; x < map2d.getWidth(); x++) {
            toRemove.push({ x, y });
        }
    }

    map2d.removeTiles(toRemove);

    cc.iterateIsoRect(map2d.getShowRect(), (x, y) => {
        map2d.showTile(x, y);
    });
};

Map2d.setTileLevelsVisible = function (tileLevelsVisible) {
    Map2d.tileLevelsVisible = tileLevelsVisible;

    const map2d = Map2d.currentMap;
    const mapView = map2d.onDiscoverMapView();
    const movingNode = cleverapps.Scenes.GetMovingNode(mapView);
    if (mapView.levelsLables) {
        mapView.levelsLables.forEach((label) => {
            label.removeFromParent();
        });
    }

    mapView.levelsLables = [];

    if (Map2d.tileLevelsVisible) {
        cc.iterateIsoRect(map2d.visibleBoxRect, (x, y) => {
            const level = map2d.calcGroundLevel(x, y);
            const tile = mapView.getCellLayerTile(Map2d.LAYER_GROUND, x, y);
            if (tile) {
                const label = cleverapps.UI.generateOnlyText(level, cleverapps.styles.FONTS.WHITE_TEXT);
                label.setAlignment({ align: "center" }, { align: "center" });
                mapView.levelsLables.push(label);
                tile.addChild(label);
                label.replaceParentSamePlace(movingNode);
            }
        });
    }
};

FogBlock.prototype.click = cleverapps.extendFunc(FogBlock.prototype.click, function (...args) {
    const time = Date.now();
    const timeout = 200;

    if (time - (this._toolLastClick || 0) < timeout) {
        clearTimeout(this.clickTimeout);
        delete this.clickTimeout;

        this._toolLastClick = 0;

        FogBlock.OpenDebug(this.id);
    } else {
        this._toolLastClick = time;
        const _super = this._super;
        this.clickTimeout = setTimeout(() => {
            _super.apply(this, args);

            delete this.clickTimeout;
        }, timeout);
    }
});

Map2d.getDebugSceneComponent = function () {
    const SceneComponent = typeof Map2dLocationSceneComponent !== "undefined" ? Map2dLocationSceneComponent : HomefixSceneComponent;
    return cleverapps.Scenes.GetSceneComponent(SceneComponent);
};

Map2d.getDebugScroll = function (sceneComponent) {
    return sceneComponent.map || sceneComponent.mapView;
};

FogBlock.OpenDebug = function (targetId) {
    const sceneComponent = Map2d.getDebugSceneComponent();

    const merge = (typeof Map2dLocation !== "undefined" && Map2dLocation.currentLocation)
        || (typeof Homefix !== "undefined" && Homefix.currentHomefix);
    const library = cleverapps.unitsLibrary;
    const fogs = merge.map.fogs.blocks;

    if (merge.tutorial && merge.tutorial.finishAll) {
        merge.tutorial.finishAll();
    }

    const fogsToOpen = [];
    const findFogParent = function (fog) {
        fogsToOpen.unshift(fog);
        const options = fog.options || {};
        options.conditions = options.conditions || {};
        if (options.parentFogId !== undefined && fogs[options.parentFogId]) {
            findFogParent(fogs[options.parentFogId]);
        }
    };
    findFogParent(fogs[targetId]);

    if (merge.counter && merge.quests) {
        merge.counter.setTimeout(() => {
            merge.quests.quests = merge.quests.quests.filter((quest) => !quest.getTutorial());
            merge.quests.quests.forEach((quest) => {
                quest.setFresh(false);
            });
            merge.quests.save();
        }, 1000);
    }

    fogsToOpen.forEach((fog) => {
        const options = fog.options || {};
        options.conditions = options.conditions || {};

        merge.addReward && merge.addReward("wands", options.price);
        fog.unlock();

        if (options.conditions.level) {
            while (cleverapps.gameLevel.getLevel() < options.conditions.level) {
                cleverapps.exp.setExp(cleverapps.gameLevel.nextLevelThreshold(), true);
                cleverapps.gameLevel.moveToNextLevel();
            }
            cleverapps.exp.onChange();
        }

        if (options.conditions.hero && !library.isHeroAvailable(options.conditions.hero)) {
            let unit = {
                code: options.conditions.hero,
                stage: Families[options.conditions.hero].units.length - 1
            };

            let cell = sceneComponent.innerMap.getCellByCoordinates(Map2d.getDebugScroll(sceneComponent).getCurrentPosition());
            cell = merge.map.findEmptySlot(cell.x, cell.y, unit, { radius: 0 });

            if (cell) {
                unit = new Unit(unit);
                unit.setPosition(cell.x, cell.y);
                merge.map.add(Map2d.LAYER_UNITS, cell.x, cell.y, unit);
                merge.map.onAddUnit(cell.x, cell.y, unit);
                merge.onUnitAvailable(unit);
            }
        }
    });
};

Unit.CreateDebug = function (unit, cell) {
    const sceneComponent = Map2d.getDebugSceneComponent();

    if (!cell) {
        cell = sceneComponent.innerMap.getCellByCoordinates(Map2d.getDebugScroll(sceneComponent).getCurrentPosition());
        cell = Map2d.currentMap.findEmptySlot(cell.x, cell.y, unit, { radius: 0 });
    }

    if (cell && (Map2d.currentMap.isGround(cell.x, cell.y) || Map2d.currentMap.isWaterUnit(cell.x, cell.y))) {
        unit = new Unit(unit);
        unit.setPosition(cell.x, cell.y);
        Map2d.currentMap.add(Map2d.LAYER_UNITS, cell.x, cell.y, unit);
        Map2d.currentMap.onAddUnit(cell.x, cell.y, unit);
        Map2d.currentMap.onUnitAvailable(unit);

        const data = { unit, debug: true };
        Map2d.mapEvent(Map2d.SPAWN, data);
        cleverapps.tutorial.trigger(Map2d.SPAWN, data);

        return true;
    }
};

Unit.prototype.debugRemove = function () {
    if (cleverapps.flags.toggleDebugClick) {
        return;
    }

    if (cleverapps.focusManager.isFocused() || cleverapps.config.name === "wordsoup" || Map2d.currentMap.getUnit(this.x, this.y) !== this) {
        return;
    }
    const buildable = this.findComponent(Buildable);

    const worker = Map2d.currentMap.workers && Map2d.currentMap.workers.findAssigned(this);
    if (worker) {
        worker.clearAssignment();
    }

    if (buildable && Map2d.currentMap.workers && Map2d.currentMap.workers.findInstantAssigned(buildable)) {
        return;
    }

    const grounded = this.findComponent(Grounded);

    if (this.view && this.view.getParent() === Map2d.currentMap.getMapView().animations) {
        return;
    }

    InfoView.CloseInfo();

    this.onDestruction(grounded);
    this.remove(true);
    this.onClickEvent = function () {};
    Map2d.currentMap.blockedGrounds.updateBlockedGrounds();
    Map2dLocation.currentLocation.counter.trigger();
};

if (engine === "cocos2d") {
    UnitView.prototype.hideTouchArea = function () {
        if (this.savedTouchArea) {
            this.savedTouchArea.removeFromParent();
            this.savedTouchArea = undefined;
        }
    };

    UnitView.prototype.showTouchArea = function () {
        this.hideTouchArea();

        const used = {};
        const pool = [];
        let points = [];
        const siblings = [{ x: 1, y: 0 }, { x: 0, y: -1 }, { x: -1, y: 0 }, { x: 0, y: 1 }];

        const directions = [];
        let i = 0, j = 0, k = 1, l = 0, x = 0, y = 0;
        for (; k < 6;) {
            x += siblings[j % 4].x;
            y += siblings[j % 4].y;
            directions.push(cc.p(x, y));

            i += 1;

            if (i >= k) {
                j += 1;
                l += 1;
                i = 0;
            }

            if (l >= 2) {
                k += 1;
                l = 0;
            }
        }

        const acceptTouch = (point) => {
            point = this.convertToWorldSpace(point);
            return this.unit.checkTouchInside(cleverapps.inputDispatcher.createTouch({ location: point }));
        };

        let accepted;
        x = this.width / 2;
        for (y = this.height / 2; y < this.height * 10; ++y) {
            const point = cc.p(x, y);

            if (acceptTouch(point)) {
                accepted = point;
            } else {
                break;
            }
        }

        if (accepted) {
            pool.push(accepted);
        }

        for (i = 0; i < pool.length; ++i) {
            const current = pool[i];

            for (j = 0; j < directions.length; ++j) {
                const next = cc.p(current.x + directions[j].x, current.y + directions[j].y);
                const key = (next.x + 1000) + (next.y + 1000) * 10000;

                if (used[key]) {
                    continue;
                }
                used[key] = true;

                if (!acceptTouch(next)) {
                    continue;
                }

                for (k = 0; k < siblings.length; ++k) {
                    if (!acceptTouch(cc.p(next.x + siblings[k].x, next.y + siblings[k].y))) {
                        points.push(next);
                        pool.push(next);
                        break;
                    }
                }

                if (k !== siblings.length) {
                    break;
                }
            }
        }

        points = points.filter((point, index) => !(index % 5));

        this.savedTouchArea = new cc.DrawNode();
        this.savedTouchArea.setAnchorPoint(0, 0);
        this.savedTouchArea.setContentSize2(this.width, this.height);
        this.savedTouchArea.drawDots(points, 1.2, cc.color(0, 0, 200, 255));
        this.savedTouchArea.setLocalZOrder(1000);
        this.addChild(this.savedTouchArea);
    };
}

UnitView.prototype.handleClick = cleverapps.extendFunc(UnitView.prototype.handleClick, function (...args) {
    if (cleverapps.flags.toggleDebugClick) {
        return this._super(...args);
    }

    if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.c) && cleverapps.config.name !== "wordsoup") {
        const map = Map2d.currentMap;
        const position = map.findEmptySlot(this.unit.x, this.unit.y, this.unit);
        if (position && !["thirdelement", "t"].includes(this.unit.code)) {
            const unit = new Unit(this.unit);
            unit.setPosition(position.x, position.y);
            map.add(Map2d.LAYER_UNITS, unit.x, unit.y, unit);
            map.onAddUnit(unit.x, unit.y, unit);
            map.onUnitAvailable(unit);
            unit.onAdd();
        }
        return;
    }

    if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.x)) {
        const url = cleverapps.RestClient.standsWeb(`/?unitsDemo=${cleverapps.meta.selectedLocationId()}&code=${this.unit.code}`);
        connector.platform.openUrl(url);
        return;
    }

    const locked = this.unit.findComponent(LockedComponent);
    if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.l) && locked) {
        locked.setLockActive(!locked.isLockActive());
        return;
    }

    if (this._toolLastClick + PointerHandler.DOUBLE_CLICK_WAIT > Date.now()) {
        const unitRemoved = this.unit.debugRemove(true);
        if (unitRemoved !== false) {
            return true;
        }
    }

    this._toolLastClick = Date.now();
    return this._super(...args);
});

Map2dInnerView.prototype.addControls = cleverapps.extendFunc(Map2dInnerView.prototype.addControls, function (...args) {
    cleverapps.pointerManager.create(this, {
        onPressed: function (touch) {
            if (touch.getButton() !== 2) {
                return;
            }

            const unit = this.findTouchUnit(touch);
            if (unit) {
                if (cleverapps.inputDispatcher.isPressed(InputDispatcher.KEY.shift)) {
                    Map2d.currentMap.listAvailableUnits(unit).forEach((unit) => {
                        unit.debugRemove();
                    });
                } else {
                    unit.debugRemove();
                }
            }
        }.bind(this)
    });

    this._super(...args);
});